import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, Col, Form, Row, Alert, Spinner } from "react-bootstrap";
import bg2 from "../assets/img/bg02.jpg";
import logo from "../assets/img/logo.jpeg";

const styles = `
  .forgot-container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  }
  
  .forgot-card {
    border: none;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0,0,0,0.2);
  }
  
  .forgot-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 30px;
    text-align: center;
    color: white;
  }
  
  .forgot-body {
    padding: 40px;
  }
  
  .btn-gradient {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    padding: 12px;
    font-weight: 600;
    color: white;
    transition: all 0.3s ease;
  }
  
  .btn-gradient:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
  }
  
  .btn-gradient:disabled {
    opacity: 0.7;
    transform: none;
  }
`;

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError("Veuillez saisir votre adresse email");
      return;
    }

    setLoading(true);
    setError("");
    setSuccess(false);

    try {
      const response = await fetch(
        'https://sawd.julesferry-ga.com/api/forgot_password.php',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email })
        }
      );

      const data = await response.json();

      if (data.success) {
        setSuccess(true);
        setTimeout(() => navigate("/pages/signin2"), 5000);
      } else {
        setError(data.message || "Une erreur est survenue");
      }
    } catch (err) {
      setError("Erreur de connexion au serveur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{styles}</style>
      <div className="forgot-container">
        <div className="container">
          <Row className="justify-content-center">
            <Col md={8} lg={6}>
              <Card className="forgot-card">
                <div className="forgot-header">
                  <img 
                    src={logo} 
                    style={{ 
                      height: "60px", 
                      width: "60px",
                      borderRadius: "50%", 
                      marginBottom: "15px",
                      border: "3px solid white"
                    }} 
                    alt="Logo" 
                  />
                  <h3>Mot de passe oublié ?</h3>
                  <p className="mb-0">Ne vous inquiétez pas, nous sommes là pour vous aider</p>
                </div>
                
                <div className="forgot-body">
                  {error && (
                    <Alert variant="danger" onClose={() => setError("")} dismissible>
                      <i className="ri-error-warning-line me-2"></i>
                      {error}
                    </Alert>
                  )}
                  
                  {success && (
                    <Alert variant="success">
                      <i className="ri-checkbox-circle-line me-2"></i>
                      Un email de réinitialisation vous a été envoyé. Vérifiez votre boîte de réception.
                      <br />
                      <small>Redirection vers la page de connexion dans 5 secondes...</small>
                    </Alert>
                  )}

                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-4">
                      <Form.Label className="fw-semibold">Adresse Email</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="votre@email.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={loading || success}
                        size="lg"
                        required
                      />
                      <Form.Text className="text-muted">
                        Nous enverrons un lien de réinitialisation à cette adresse.
                      </Form.Text>
                    </Form.Group>

                    <div className="d-grid gap-3">
                      <Button 
                        type="submit" 
                        className="btn-gradient"
                        disabled={loading || success}
                        size="lg"
                      >
                        {loading ? (
                          <>
                            <Spinner size="sm" className="me-2" />
                            Envoi en cours...
                          </>
                        ) : (
                          "Envoyer le lien de réinitialisation"
                        )}
                      </Button>
                      
                      <Button 
                        variant="link" 
                        onClick={() => navigate("/pages/signin2")}
                        className="text-decoration-none"
                      >
                        <i className="ri-arrow-left-line me-2"></i>
                        Retour à la connexion
                      </Button>
                    </div>
                  </Form>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}